export default __webpack_public_path__ + "static/media/danimotaoficial.8d46e554.jpg";